import { render, staticRenderFns } from "./OtherPlayer.vue?vue&type=template&id=4eba6766"
import script from "./OtherPlayer.vue?vue&type=script&lang=ts"
export * from "./OtherPlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports